export default __webpack_public_path__ + "static/media/about_02_black.dd04ed04.svg";